import PropTypes from "prop-types"
import { Flex, Skeleton } from "antd"
import { useDevice } from "hooks/useDevice"
import styles from "../../index.module.css"
import cardStyles from "./ExperienceCard.module.css"

// An order's experience while its own details load (QA Ticketing #58): the card's shape, with what
// the order already says about it (title, status, number, date and time) and the photo, guests and
// total pulsing, so the page doesn't jump when the details arrive.
const ExperienceCardSkeleton = ({ title, statusTag = null, meta = "" }) => {
  const { isMobile, isTablet } = useDevice()
  const photoClassName = `${cardStyles.photo} ${isTablet ? cardStyles.photoTablet : ""} ${isMobile ? cardStyles.photoMobile : ""}`
  const isCompact = isMobile || isTablet

  return (
    <div className={`${styles.card} ${cardStyles.card}`} aria-busy="true">
      <Flex>
        <div className={photoClassName}>
          <Skeleton.Node active className={cardStyles.photoSkeleton} />
        </div>
        <Flex gap={24} className={`${cardStyles.details} ${isCompact ? cardStyles.detailsTablet : ""}`}>
          <Flex vertical gap={12} className={styles.expBody}>
            <Flex vertical gap={8}>
              <Flex align="center" gap={12} wrap>
                <span className={cardStyles.title}>{title}</span>
                {statusTag}
              </Flex>
              {meta && <span className={styles.expCode}>{meta}</span>}
            </Flex>
            <Skeleton.Input active size="small" className={cardStyles.lineSkeleton} />
            {isCompact && <Skeleton.Input active size="small" className={cardStyles.totalSkeleton} />}
          </Flex>
          {!isCompact && (
            <Flex vertical justify="flex-end" align="flex-end" className={cardStyles.side}>
              <Skeleton.Input active size="small" className={cardStyles.totalSkeleton} />
            </Flex>
          )}
        </Flex>
      </Flex>
    </div>
  )
}

ExperienceCardSkeleton.propTypes = {
  title: PropTypes.string,
  // The booking's status tag, already known from the order.
  statusTag: PropTypes.node,
  // "number · date · start time" from the order's entry for this booking.
  meta: PropTypes.string
}

export default ExperienceCardSkeleton
